import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "course" }
const _hoisted_2 = { class: "course-info" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "text-h2 mb-6" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "text-h4 mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_11 = { key: 0 }

import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ROUTER_NAME } from '../../router'
import Course from '../../../api/v2/models/course'
import api from '../../../api/v2/api'
import CourseButton from '../organisms/CourseButton.vue'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'CourseDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const mobile = ref(false)
const course = ref<Course | null>(null)
const isMobile = ref(false)

const user = computed(() => userState.user)

const breadcrumbItems = computed(() => {
  if (route.params.userGoalId) {
    return [
      {
        text: 'ゴール一覧',
        disabled: false,
        exact: true,
        to: `/classroom/user-goals`
      },
      {
        text: 'ゴール詳細',
        disabled: false,
        exact: true,
        to: `/classroom/user-goals/${route.params.userGoalId}`
      },
      {
        text: course.value ? course.value.name : '',
        disabled: true,
        exact: true,
      }
    ]
  }

  return [
    {
      text: 'コース一覧',
      disabled: false,
      exact: true,
      to: '/classroom/courses'
    },
    {
      text: course.value ? course.value.name : '',
      disabled: true
    }
  ]
})

// Type-safe computed property for route query param
const lessonIdQuery = computed(() => getQueryString(route.query, 'lesson_id'))

const getCourse = async () => {
  try {
    course.value = await api.course.show(route.params.courseId as string)
    headerState.setTitle(course.value.name)

    // レッスン指定される場合、直接のenrrllmentに移動する
    if (lessonIdQuery.value && user.value) {
      api.enrollment.show({
        user_id: user.value.id,
        course_id: course.value.id
      }).then(enrollment => {
        if (enrollment && enrollment.id) {
          router.push(`/classroom/my-courses/${route.params.courseId}?lesson_id=${lessonIdQuery.value}`)
        }
      })
    }

  } catch(e) {
  }
}

const onResize = () => {
  isMobile.value = window.innerWidth < 600
}

watch(() => route.params.courseId, () => {
  getCourse()
})

onMounted(() => {
  getCourse()
  onResize()
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (course.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_AppBreadcrumb, { items: breadcrumbItems.value }, null, 8 /* PROPS */, ["items"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass({ 'pc-width': !isMobile.value })
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_col, {
                  lg: "6",
                  class: "mb-9"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(course.value.name), 1 /* TEXT */),
                    _createElementVNode("p", {
                      class: "my-3",
                      innerHTML: course.value.description
                    }, null, 8 /* PROPS */, _hoisted_5)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  lg: "6",
                  class: "pe-8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: course.value.image.url
                    }, null, 8 /* PROPS */, ["src"]),
                    _createVNode(CourseButton, {
                      course: course.value,
                      user: user.value,
                      class: "mt-3"
                    }, null, 8 /* PROPS */, ["course", "user"])
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass({ 'pc-width': !isMobile.value })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (course.value.chapters.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(course.value.chapters, (chapter) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "d-flex",
                          key: chapter.id
                        }, [
                          _createVNode(_component_v_col, { class: "bg-white" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(chapter.name), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(chapter.description), 1 /* TEXT */),
                              (chapter.lessons.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapter.lessons, (lesson, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "mb-3"
                                      }, [
                                        _createVNode(_component_v_icon, {
                                          size: "small",
                                          color: "pink",
                                          class: "me-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createTextVNode("mdi-check-circle", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }),
                                        _createTextVNode("Lesson " + _toDisplayString((index + 1)) + ": " + _toDisplayString(lesson.name), 1 /* TEXT */)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_v_col, { class: "bg-white" }, {
                          default: _withCtx(() => [
                            (course.value.lessons.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(course.value.lessons, (lesson, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "mb-3"
                                    }, [
                                      _createVNode(_component_v_icon, {
                                        size: "small",
                                        color: "pink",
                                        class: "me-1"
                                      }, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                          _createTextVNode("mdi-check-circle", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }),
                                      _createTextVNode("Lesson " + _toDisplayString((index + 1)) + ": " + _toDisplayString(lesson.name), 1 /* TEXT */)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]))
                ]),
                _: 1 /* STABLE */
              })
            ])
          ], 2 /* CLASS */)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})